import React from "react";
import ListView from "../Common/Views/ListView";

const VehiclesList = ({
    filters = {},
    addButton = true,
    onSelect = null, // a function to override the table row click action (default is to navigate to details page)

    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.
}) => {

    // Columns configuration for rendering items list
    const columnsConfig = {
        registrationNumber: {
            key: 'registrationNumber',
            label: 'Registration number',
            render: row => row.registrationNumber
        },
        make: {
            key: 'make',
            label: 'Make',
            render: row => row.make
        },
        model: {
            key: 'model',
            label: 'Model',
            render: row => row.model
        },
        year: {
            key: 'year',
            label: 'Year',
            render: row => row.year
        },
        ownerName: {
            key: 'ownerName',
            label: 'Owner',
            render: row => row.owner?.name
        },
        ownerPhone: {
            key: 'ownerPhone',
            label: 'Phone number',
            render: row => row.owner?.phoneNumber
        },
        isActive: {
            key: 'isActive',
            label: 'Active',
            render: row => row.isActive ? 'Yes' : 'No'
        },
    };


    return <ListView
        title="Vehicles"
        apiPath="/tenants/vehicles"
        filters={filters}
        addButton={addButton}
        addButtonLabel="Add new vehicle"
        addPath="/vehicles/add"
        rowClickPath={(vehicle) => `/vehicles/${vehicle.id}`}
        onSelect={onSelect}
        columnsConfig={columnsConfig}
        columns={columns}
        searchBox={true}
        searchAttributes={[
            { name: "registrationNumber", label: "Registration number", type: "text" },
        ]}
        noResultsMessage="No vehicles found"
    />
};

export default VehiclesList;
